import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormTitle,
  title: 'Form Title',
  category: ComponentCategory.FormControls,
};
